import React from 'react'
import { useGoal } from 'gatsby-plugin-fathom'
import Navigation from '../Navigation'
import Container from '../Container'
import { Desktop, Mobile } from '../MediaQuery'
import {
  HeaderWrapper,
  HeaderInnerWrapper,
  HeaderButton,
  HeaderImgLink,
  HeaderImg,
} from './Header.styles'
import logo40 from '../../assets/logo-40.jpg'
import logo80 from '../../assets/logo-80.jpg'
import Icon from '../Icon'

const Header = () => {
  const handleGoal = useGoal('T43LY1DF')
  return (
    <HeaderWrapper>
      <Container horizontal header>
        <HeaderInnerWrapper>
          <HeaderImgLink to="/">
            <picture>
              <source media="(max-width: 768px)" srcSet={logo80} />
              <source media="(min-width: 768px)" srcSet={logo40} />
              <HeaderImg src={logo40} alt="Logo" />
            </picture>
          </HeaderImgLink>
          <Mobile>
            <div>Yago Gonzalez</div>
          </Mobile>
          <Desktop>
            <Navigation />
          </Desktop>
          <HeaderButton href="https://cv.yago.dev" onClick={handleGoal}>
            <Icon icon="file-pdf" />
            <span>CV</span>
          </HeaderButton>
        </HeaderInnerWrapper>
      </Container>
    </HeaderWrapper>
  )
}

export default Header
